<template>
  <permission-gate
    moduleKey="suajes"
    :showNoEditAlert="true"
  >
    <template #default="{ canEdit }">
      <main-breadcrumb
        :items="items"
        showBackButton
      ></main-breadcrumb>
      <main-buttons-bar :align="'space-between'">
        <template #left>
          <custom-title>Edición de imposición</custom-title>
        </template>
      </main-buttons-bar>

      <detail-container>
        <div class="detail-container">
          <el-form
            ref="formSuajeRef"
            :model="swage"
            :rules="formSuajeRules"
            size="default"
            class="form-container"
          >
            <el-row :gutter="20">
              <el-col :span="4">
                <el-form-item prop="CodigoSuaje">
                  <custom-input
                    v-model="swage.CodigoSuaje"
                    :label="'Código'"
                    :settings="{
                      placeholder: 'Código de suaje',
                    }"
                  ></custom-input>
                </el-form-item>
              </el-col>
              <el-col :span="4">
                <el-form-item prop="CodigoAdicional">
                  <custom-input
                    v-model="swage.CodigoAdicional"
                    :label="'Código adicional'"
                    :settings="{
                      placeholder: 'Código interno adicional',
                      maxlength: 100,
                    }"
                  ></custom-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item prop="Descripcion">
                  <custom-input
                    v-model="swage.Descripcion"
                    :label="'Descripción'"
                    :settings="{
                      placeholder: 'Descripción del suaje',
                      maxlength: 255,
                    }"
                  ></custom-input>
                </el-form-item>
              </el-col>
              <el-col :span="4">
                <el-form-item prop="SuajeTipo">
                  <custom-select
                    v-model="swage.SuajeTipo"
                    :label="'Tipo suaje'"
                    :settings="{
                      placeholder: 'Seleccionar tipo de suaje',
                      options: claseSuaje,
                    }"
                  ></custom-select>
                </el-form-item>
              </el-col>
              <el-col :span="4">
                <el-form-item prop="Forma">
                  <custom-select
                    v-model="swage.Forma"
                    :label="'Forma'"
                    :settings="{
                      placeholder: 'Seleccionar forma',
                      options: formaList,
                    }"
                    @update:modelValue="handleFormaChange($event)"
                  ></custom-select>
                </el-form-item>
              </el-col>
              <el-col :span="1"></el-col>
              <el-col
                :span="4"
                class="custom-col"
              >
                <div class="custom-label">Aplicación</div>
                <el-switch
                  v-model="swage.EsAutomatica"
                  active-text="Automatico"
                  inactive-text="Manual"
                  class="mb-2"
                  sieze="large"
                />
              </el-col>
              <el-col
                :span="3"
                class="custom-col"
              >
                <div class="custom-label">Pleca</div>
                <el-switch
                  v-model="swage.TienePleca"
                  active-text="Si"
                  inactive-text="No"
                  class="mb-2"
                  sieze="large"
                />
              </el-col>
            </el-row>
            <el-row :gutter="24">
              <el-form-item prop="MedidaEjeMm">
                <custom-input-number
                  v-model="swage.MedidaEjeMm"
                  :label="'Medida al Eje (mm)'"
                  :settings="{
                    placeholder: 'Medida al Eje (mm)',
                    precision: 4,
                    step: 0.01,
                    controls: false,
                  }"
                ></custom-input-number>
              </el-form-item>
              <el-form-item prop="MedidaDesarrolloMm">
                <custom-input-number
                  v-model="swage.MedidaDesarrolloMm"
                  :label="'Medida Desarrollo (mm)'"
                  :settings="{
                    placeholder: 'Medida desarrollo (mm)',
                    precision: 4,
                    step: 0.01,
                    controls: false,
                  }"
                ></custom-input-number>
              </el-form-item>
              <el-form-item prop="MedidaEjeIn">
                <custom-input-number
                  v-model="swage.MedidaEjeIn"
                  :label="'Medida al Eje (in)'"
                  :settings="{
                    placeholder: 'Medida al Eje (in)',
                    precision: 4,
                    disabled: true,
                    step: 0.01,
                    controls: false,
                  }"
                ></custom-input-number>
              </el-form-item>
              <el-form-item prop="MedidaDesarrolloIn">
                <custom-input-number
                  v-model="swage.MedidaDesarrolloIn"
                  :label="'Medida Desarrollo (in)'"
                  :settings="{
                    placeholder: 'Medida desarrollo (in)',
                    precision: 4,
                    disabled: true,
                    step: 0.01,
                    controls: false,
                  }"
                ></custom-input-number>
              </el-form-item>
              <el-col :span="2"></el-col>
              <el-col
                :span="4"
                class="custom-col"
              >
                <div class="custom-label">Tipo corte</div>
                <el-switch
                  v-model="swage.EsCorteCompleto"
                  active-text="Completo"
                  inactive-text="Medio corte"
                  class="mb-2"
                  sieze="large"
                />
              </el-col>
              <el-col
                :span="3"
                class="custom-col"
              >
                <div class="custom-label">Activo</div>
                <el-switch
                  v-model="swage.Activo"
                  active-text="Activo"
                  inactive-text="Inactivo"
                  class="mb-2"
                  sieze="large"
                />
              </el-col>
            </el-row>
            <el-row :gutter="24">
              <el-col :span="4">
                <el-form-item prop="CilindroTipo">
                  <custom-select
                    v-model="swage.CilindroTipo"
                    :label="'Tipo Cilindro'"
                    :settings="{
                      placeholder: 'Seleccionar cilindro',
                      options: cilindroTipoList,
                    }"
                  ></custom-select>
                </el-form-item>
              </el-col>
              <el-form-item prop="Engranaje">
                <custom-input-number
                  v-model="swage.Engranaje"
                  :label="'Engrane'"
                  :settings="{
                    placeholder: 'Engrane',
                    precision: 0,
                    step: 0.01,
                    controls: false,
                  }"
                ></custom-input-number>
              </el-form-item>
              <el-form-item prop="Desarrollo">
                <custom-input-number
                  v-model="swage.Desarrollo"
                  :label="'Desarrollo (mm)'"
                  :settings="{
                    placeholder: 'Desarrollo',
                    precision: 4,
                    step: 0.01,
                    disabled: !esSuajePlano,
                    controls: false,
                  }"
                ></custom-input-number>
              </el-form-item>
              <el-form-item prop="AnchoOptimoMaterial ">
                <custom-input-number
                  v-model="swage.AnchoOptimoMaterial"
                  :label="'Ancho mínimo (mm)'"
                  :settings="{
                    placeholder: 'Ancho mínimo',
                    precision: 4,
                    step: 0.01,
                    disabled: true,
                    controls: false,
                  }"
                ></custom-input-number>
              </el-form-item>
            </el-row>
            <el-row :gutter="24">
              <el-form-item prop="EtiquetasEje">
                <custom-input-number
                  v-model="swage.EtiquetasEje"
                  :label="'Etiquetas eje'"
                  :settings="{
                    placeholder: 'Etiquetas eje',
                    precision: 0,
                    step: 0.01,
                    controls: false,
                  }"
                ></custom-input-number>
              </el-form-item>
              <el-form-item prop="EtiquetasDesarrollo">
                <custom-input-number
                  v-model="swage.EtiquetasDesarrollo"
                  :label="'Etiquetas desarrollo'"
                  :settings="{
                    placeholder: 'Etiquetas desarrollo',
                    precision: 0,
                    step: 0.01,
                    disabled: false,
                    controls: false,
                  }"
                ></custom-input-number>
              </el-form-item>
              <el-form-item prop="MinEtiquetaImpresa">
                <custom-input-number
                  v-model="swage.MinEtiquetaImpresa"
                  :label="'Minimo etiqueta impresa'"
                  :settings="{
                    placeholder: 'Minimo etiqueta impresa',
                    precision: 0,
                    step: 0.01,
                    controls: false,
                  }"
                ></custom-input-number>
              </el-form-item>
              <el-form-item prop="MinEtiquetaSinImpresion">
                <custom-input-number
                  v-model="swage.MinEtiquetaSinImpresion"
                  :label="'Minimo etiqueta sin impresión'"
                  :settings="{
                    placeholder: 'Minimo etiqueta sin impresión',
                    precision: 0,
                    step: 0.01,
                    controls: false,
                  }"
                ></custom-input-number>
              </el-form-item>
              <el-form-item
                prop="Material"
                style="margin-left: 2%"
              >
                <div class="custom-label">Material</div>
                <el-autocomplete
                  v-model="swage.Material.Descripcion"
                  size="default"
                  :value-key="'Descripcion'"
                  :fetch-suggestions="handleSearch"
                  clearable
                  placeholder="Ingresar el item"
                  style="width: 100%"
                  @select="handleMaterialSelect"
                />
              </el-form-item>
            </el-row>
            <el-row :gutter="24">
              <el-form-item prop="GapEjeMm">
                <custom-input-number
                  v-model="swage.GapEjeMm"
                  :label="'Gap al Eje (mm)'"
                  :settings="{
                    placeholder: 'Gap al Eje (mm)',
                    precision: 4,
                    step: 0.01,
                    controls: false,
                  }"
                ></custom-input-number>
              </el-form-item>
              <el-form-item prop="GapDesarrolloMm">
                <custom-input-number
                  v-model="swage.GapDesarrolloMm"
                  :label="'Gap al Desarrollo (mm)'"
                  :settings="{
                    placeholder: 'Gap desarrollo (mm)',
                    precision: 4,
                    step: 0.01,
                    disabled: !esSuajePlano,
                    controls: false,
                  }"
                ></custom-input-number>
              </el-form-item>
              <el-form-item prop="GapEjeIn">
                <custom-input-number
                  v-model="swage.GapEjeIn"
                  :label="'Gap al Eje (in)'"
                  :settings="{
                    placeholder: 'Gap al Eje (in)',
                    precision: 4,
                    step: 0.01,
                    disabled: true,
                    controls: false,
                  }"
                ></custom-input-number>
              </el-form-item>
              <el-form-item prop="GapDesarrolloIn">
                <custom-input-number
                  v-model="swage.GapDesarrolloIn"
                  :label="'Gap al Desarrollo (in)'"
                  :settings="{
                    placeholder: 'gap al Desarrollo (in)',
                    precision: 4,
                    step: 0.01,
                    disabled: true,
                    controls: false,
                  }"
                ></custom-input-number>
              </el-form-item>
              <el-col :span="6">
                <el-form-item prop="familiaMaterialSelected">
                  <custom-select
                    v-model="familiaMaterialSelected"
                    :label="'Familia'"
                    :settings="{
                      placeholder: 'Seleccionar familia',
                      multiple: true,
                      options: materiaPrimaFamilias,
                    }"
                  ></custom-select>
                </el-form-item>
              </el-col>
            </el-row>

            <el-form-item prop="Observaciones">
              <div class="custom-label">Observaciones</div>
              <el-input
                v-model="swage.Observaciones"
                type="textarea"
                spanColumn="24"
                placeholder="Notas técnicas sobre el troquel"
                ,
                :rows="3"
              ></el-input>
            </el-form-item>

            <el-row :gutter="24">
              <div style="display: flex; gap: 12px; justify-content: flex-end; width: 100%">
                <el-button @click="router.back()">Volver</el-button>
                <el-button
                  type="primary"
                  :disabled="!canEdit"
                  @click="handleSave"
                >
                  Guardar cambios
                </el-button>
              </div>
            </el-row>
          </el-form>
          <!-- 🆕 COTI-480: Gestión de adaptadores cilindro-desarrollo -->
        </div>
      </detail-container>
    </template>
  </permission-gate>
</template>
<script setup>
import {
  onBeforeMount,
  onMounted,
  ref,
  computed,
  watch,
} from 'vue';
import { useSwageStore } from '@/stores/swage_store.js';
import { storeToRefs } from 'pinia';
import {
  useRoute,
  useRouter,
} from 'vue-router';
import { useFormaStore } from '@/stores/forma/forma_store.js';
import { useCilindroTipoStore } from '@/stores/cilindro-tipo/cilindro-tipo';
import { useConfiguracionStore } from '@/stores/configuracion-general';
import { useMaterialStore } from '@/stores/materiales_store.js';
import { useRequestStore } from '@/views/requests/stores/request_store.js';
import { useMateriaPrimaFamiliaStore } from '@/stores/materia_prima_familia/materia_prima_familia_store';
import MainBreadcrumb from '@/shared/layout/main/main_breadcrum.vue';
import MainButtonsBar from '@/shared/layout/main/buttons_bar/main_buttons_bar.vue';
import DetailContainer from '@/shared/layout/detail/detail_container.vue';
import CustomTitle from '@/shared/components/custom_title.vue';
import CustomInput from '@/shared/components/custom_input.vue';
import CustomInputNumber from '@/shared/components/custom_input_number.vue';
import CustomConfirmButtons from '@/shared/components/custom_confirm_buttons.vue';
import CustomSelect from '@/shared/components/custom_select.vue';
import { useMessageError } from '@/shared/composables/message_error.js';
import { useMessageSuccess } from '@/shared/composables/message_success.js';
import { useLoading } from '@/shared/composables/loading.js';
import { calcularGapDesarrollo } from '@/shared/composables/useSuajeAdaptador.js';
import { ElNotification } from 'element-plus';
import PermissionGate from '@/shared/components/permission_gate.vue';

const route = useRoute();
const router = useRouter();
const formaStore = useFormaStore();
const cilindroTipoStore = useCilindroTipoStore();
const requestStore = useRequestStore();
const configuracionStore = useConfiguracionStore();
const materialStore = useMaterialStore();
const materiaPrimaFamiliaStore = useMateriaPrimaFamiliaStore();

const { findAllfamiliaMaterialHTTP } = requestStore;
const { familiaMaterial } = storeToRefs(requestStore);
const { firstCilindroTipo } = cilindroTipoStore;
const { cilindroTipoList } = storeToRefs(cilindroTipoStore);
const { firstForma } = formaStore;
const { formaList } = storeToRefs(formaStore);
const swageStore = useSwageStore();
const { configuracion } = storeToRefs(configuracionStore);
const { materiaPrimaFamilias } = storeToRefs(materiaPrimaFamiliaStore);

const { findConfiguracionByCodigoHTTP } = configuracionStore;
const { findSuajeByCodigoHTTP, updateSuajeHTTP, findAllClaseSuajeHTTP, resetNewSwage } = swageStore;
const { searchMaterialHTTP } = materialStore;
const { swage, claseSuaje } = storeToRefs(swageStore);
const formSuajeRef = ref(null);
const familiaMaterialSelected = ref([]);

// Un suaje "plano" no usa engrane y su desarrollo lo define el usuario
const esSuajePlano = computed(() => swage.value.SuajeTipo?.ClaveInterna === 'plano');

const formSuajeRules = computed(() => ({
  CodigoSuaje: [{ required: true, message: 'Ingresar código suaje', trigger: 'blur' }],
  EtiquetasEje: [{ required: true, message: 'Ingresar etiqueta eje', trigger: 'blur' }],
  Engranaje: esSuajePlano.value
    ? []
    : [{ required: true, message: 'Ingresar engrane', trigger: 'blur' }],
  Desarrollo: esSuajePlano.value
    ? [{ required: true, message: 'Ingresar desarrollo (mm)', trigger: 'blur' }]
    : [],
  GapEjeMm: [{ required: true, message: 'Ingresar gap Eje (mm)', trigger: 'blur' }],
  MedidaEjeMm: [{ required: true, message: 'Ingresar medida eje (mm)', trigger: 'blur' }],
  MedidaDesarrolloMm: [
    { required: true, message: 'Ingresar medida desarrollo (mm)', trigger: 'blur' },
  ],
  CodigoSuajeTipo: [{ required: true, message: 'Seleccionar un tipo', trigger: 'change' }],
  Forma: [{ required: true, message: 'Seleccionar una forma', trigger: 'change' }],
  // CilindroTipo: [{ required: true, message: 'Seleccionar un tipo', trigger: 'change' }],
  EtiquetasDesarrollo: [
    {
      validator: (rule, value, callback) => {
        if (value < 1) {
          callback(new Error('El valor de Etiquetas Desarrollo debe ser mayor a uno'));
        } else {
          callback();
        }
      },
      trigger: 'change',
    },
  ],
  GapDesarrolloMm: [
    {
      validator: (rule, value, callback) => {
        if (value < 0) {
          callback(new Error('El gap desarrollo (mm) no puede ser negativo'));
        } else if (value < configuracion.value.Valor) {
          callback(
            new Error(
              `El gap desarrollo (mm) no puede ser menor al gap mínimo de ${configuracion.value.Valor}`,
            ),
          );
        } else {
          callback();
        }
      },
      trigger: 'change',
    },
  ],
}));

const items = [
  { label: 'Inicio', to: '/page/swage/list', replace: false },
  { label: 'Edicion', to: null, replace: false },
];

function toFourDecimals(num) {
  return parseFloat(num.toFixed(4));
}
// Watcher para convertir mm a in
watch(
  () => swage.value.MedidaEjeMm,
  (nuevoValor) => {
    swage.value.MedidaEjeIn = toFourDecimals(nuevoValor * 0.0393701); // Conversión de mm a in
  },
);

watch(
  () => swage.value.GapEjeMm,
  (nuevoValor) => {
    swage.value.GapEjeIn = toFourDecimals(nuevoValor * 0.0393701); // Conversión de mm a in
  },
);

watch(
  () => swage.value.GapDesarrolloMm,
  (nuevoValor) => {
    swage.value.GapDesarrolloIn = toFourDecimals(nuevoValor * 0.0393701); // Conversión de mm a in
  },
);

watch(
  () => swage.value.MedidaDesarrolloMm,
  (nuevoValor) => {
    swage.value.MedidaDesarrolloIn = toFourDecimals(nuevoValor * 0.0393701); // Conversión de mm a in
  },
);

// Verifica que solo haya un watcher para GapEjeMm a GapEjeIn
watch(
  () => swage.value.GapEjeMm,
  (nuevoValor) => {
    swage.value.GapEjeIn = toFourDecimals(nuevoValor * 0.0393701); // Conversión de mm a in
  },
);

// Watcher para Desarrollo y Engranaje: en suajes planos el desarrollo lo carga el usuario,
// en el resto se recalcula a partir del engrane
watch(
  [() => swage.value.Engranaje, esSuajePlano],
  ([nuevoEngranaje, esPlano]) => {
    if (!esPlano && nuevoEngranaje !== null) {
      swage.value.Desarrollo = toFourDecimals(nuevoEngranaje * 3.175);
    }
  },
  { immediate: true },
);

// Al pasar a plano, limpiar la validación pendiente de Engranaje (deja de ser obligatorio)
watch(esSuajePlano, (esPlano) => {
  if (esPlano) {
    formSuajeRef.value?.clearValidate('Engranaje');
  }
});

// Watcher para AnchoOptimoMaterial
watch(
  [() => swage.value.MedidaEjeMm, () => swage.value.GapEjeMm, () => swage.value.EtiquetasEje],
  ([nuevaMedida, nuevoGap, nuevaEtiqueta]) => {
    if (nuevaMedida !== null && nuevoGap !== null && nuevaEtiqueta !== null) {
      swage.value.AnchoOptimoMaterial = toFourDecimals((nuevaMedida + nuevoGap) * nuevaEtiqueta);
    }
  },
  { immediate: true },
);

// Watcher para GapDesarrolloMm: en suajes planos el gap lo carga el usuario,
// en el resto se recalcula a partir del desarrollo, la medida y las etiquetas
watch(
  [
    () => swage.value.Desarrollo,
    () => swage.value.MedidaDesarrolloMm,
    () => swage.value.EtiquetasDesarrollo,
    esSuajePlano,
  ],
  ([nuevoDesarrollo, nuevaMedida, nuevaEtiqueta, esPlano]) => {
    if (!esPlano && nuevoDesarrollo !== null && nuevaMedida !== null && nuevaEtiqueta !== null) {
      swage.value.GapDesarrolloMm = calcularGapDesarrollo(
        nuevoDesarrollo,
        nuevaEtiqueta,
        nuevaMedida,
      );
    }
  },
  { immediate: true },
);

// Verificar y asegurar que swage.Material no sea null
watch(
  swage,
  (newSwage) => {
    if (!newSwage.Material) {
      newSwage.Material = { Descripcion: '' };
    }
  },
  { immediate: true },
);

function handleFormaChange(forma) {
  swage.value.CodigoForma = forma.Codigo;
}
onBeforeMount(() => {
  findConfiguracionByCodigoHTTP(9);
  materiaPrimaFamiliaStore.emptyList();
  materiaPrimaFamiliaStore.findAllfamiliaMaterialHTTP({
    page: 0,
    sortBy: 'Descripcion',
    sort: 'asc',
  });
  firstForma();
  firstCilindroTipo();
  findAllClaseSuajeHTTP();
  const id = route.params.id;
  if (id && +id > 0) {
    findSuajeByCodigoHTTP(id);
  }
});

watch(
  swage,
  (newValue) => {
    if (newValue && newValue.SuajeMateriaPrimaFamilia) {
      familiaMaterialSelected.value = newValue.SuajeMateriaPrimaFamilia.map(
        (item) => item.MateriaPrimaFamilia,
      );
    }
  },
  { immediate: true },
);

watch(familiaMaterialSelected, (newValue) => {
  swage.value.SuajeMateriaPrimaFamilia = [];
  familiaMaterialSelected.value.forEach((item) => {
    const newItem = {
      CodigoMateriaPrimaFamilia: item.Codigo,
      MateriaPrimaFamilia: {
        Codigo: item.Codigo,
        Descripcion: item.Descripcion,
        CodigoAdicional: item.CodigoAdicional,
        Activo: item.Activo,
      },
    };
    swage.value.SuajeMateriaPrimaFamilia.push(newItem);
  });
});

const handleMaterialSelect = (item) => {
  swage.value.Material = item;
  swage.value.CodigoMaterial = item.Codigo;
};

onMounted(async () => {
  await new Promise((resolve) => {
    const checkValue = () => {
      if (swage.value.CodigoClaseSuaje !== 0 && swage.value.CodigoClaseSuaje !== null) {
        swage.value.ClaseSuaje = claseSuaje.value.find(
          (item) => item.Codigo === swage.value.CodigoClaseSuaje,
        );
        resolve();
      } else {
        setTimeout(checkValue, 100); // Verificar cada 100 ms
      }
    };
    checkValue();
  });
});

const handleSearch = async (query, cb) => {
  let results = [];
  if (query && query.length >= 3 && query !== 'null') {
    results = await searchMaterialHTTP(query);
  }
  cb(results || []);
};

const handleSave = () => {
  formSuajeRef.value.validate(async (valid) => {
    if (valid) {
      try {
        useLoading().openLoading();

        await updateSuajeHTTP();
        useMessageSuccess().open(`Los datos se guardaron existosamente!`);
        router.go(-1);
      } catch (err) {
        useMessageError().open(`Ha ocurrido un error al intentar guardar los datos.`);
      } finally {
        useLoading().closeLoading();
      }
    } else {
      ElNotification({
        title: 'Nuevo suaje',
        message: 'Por favor, revise los campos ingresados.',
        type: 'warning',
      });
    }
  });
};

const onCancel = () => {
  resetNewSwage();
  router.go(-1);
};
</script>

<style scoped>
.custom-label {
  font-weight: 700;
  color: #111;
}
.container {
  display: flex;
  justify-content: flex-end; /* Alinea todo el contenido al final del contenedor */
}
.custom-col {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.full-width {
  width: 100%;
}
</style>
